export default __webpack_public_path__ + "static/media/warmmetabolismdrink-wide@2x.8fe90e77.jpg";